//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VipService from '@/views/personal_package/_service/coin_store'
export default {
    data() {
        return {
            items: [
                {
                    title: '通心粉专属标识',
                    desc: '在小程序中展示专属标识，彰显不同'
                },
                {
                    title: '购房新手福利',
                    desc: '购房全流程攻略，模板工具一应俱全'
                },
                {
                    title: '周边好物免费兑换',
                    desc: '通宝商城周边好物签到即可获得'
                }
            ]
        }
    },
    props: {
        auth_phone_params: Object,
        log: String,
        title: {
            type: String,
            default: '购房通邀请您成为通心粉'
        },
        show: Boolean
    },
    methods: {
        goGuide() {
            VipService.becomeVip().then((res) => {
                if (Number(res.code) === 422) {
                    wx.showToast({
                        title: res.error_message,
                        icon: 'none'
                    })
                } else {
                    if (this.log) {
                        this.$sendCtmEvtLog(this.log)
                    }
                    this.$emit('success')
                }
            })
        }
    }
}
